<div class="container">
  <span class="title">{{'blockedUser.title' | translate}}</span>
  <app-button size="large" (clickEvent)="onContactSupport()">{{'blockedUser.button' | translate}}</app-button>
</div>
